<template>
  <v-card class="rounded-0 ContactListItem" :class="{ 'is-header': header }" :flat="true"> <!-- @click="e => $emit('click', e)" -->
    <v-container class="contact-list-item-container py-2 px-0" fluid>
      <v-row justify="space-between" align="center" no-gutters class="px-3">

        <v-col cols="auto">
          <slot name="avatar" />
        </v-col>

        <v-col cols="0">
          <v-row no-gutters>

            <v-col cols="6">
              <div v-if="!!$slots.name" no-gutters class="py-1 px-1 nowraptext">
                <slot name="name" />
              </div>
              <div v-if="!!$slots.title" no-gutters class="py-1 px-1 nowraptext" style="opacity: 0.7;">
                <slot name="title" />
              </div>
            </v-col>

            <v-col cols="6">
              <div v-if="!!$slots.email" no-gutters class="py-1 px-1 nowraptext">
                <slot name="email" />
              </div>
              <div v-if="!!$slots.mobile" no-gutters class="py-1 px-1 nowraptext" style="opacity: 0.8;">
                <slot name="mobile" />
              </div>
            </v-col>

          </v-row>
        </v-col>

        <v-col cols="auto" style="width: 50px;">
          <slot name="actions" />
        </v-col>

      </v-row>
    </v-container>

    <v-divider :style="'border-color: rgb(0 0 0 /' + (header ? 18 : 8) + '%);'" />
  </v-card>
</template>


<script>
export default {
  name: "ContactListItemSlotTemplate",
  props: {
    header: Boolean,
  },
  components: {},

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped>
.ContactListItem.deactivated {
  background-color: #f5f5f5;
}

.ContactListItem:not(.deactivated) {
  background-color: white;
}

.ContactListItem {
  color: rgba(0, 0, 0, 0.87);
  transition: background-color 120ms ease;
}

.ContactListItem:not(.is-header):not(.deactivated):hover {
  background-color: #fafafa;
}

.ContactListItem.is-header {
  background-color: #f7f9fc;
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.contact-list-item-container {
  min-height: 58px;
}

.ContactListItem.is-header .contact-list-item-container {
  min-height: 42px;
}

.nowraptext {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>